import animations from "../../components/Animations";
import { BREAKPOINTS } from "../../styles/variables/Breakpoints";

export function mm() {
  const breakPointSm = BREAKPOINTS.sm;
  const breakPointMd = BREAKPOINTS.md;
  const mm = animations.matchMedia();

  mm.add(
    {
      isDesktop: `(min-width: ${breakPointMd}px)`,
      isMobile: `(max-width: ${breakPointMd - 1}px)`,
    },
    context => {
      let { isDesktop, isMobile } = context.conditions;
    }
  );

  return mm;
}
